export default function InitCKEditor() {
    const liElements = document.querySelectorAll(".text-module li");
    for (const liEl of liElements) {
        liEl.innerHTML = '<span>' + liEl.innerHTML + '</span>';
    }
}
InitCKEditor();
